import React from 'react';
import Field from './Field';

const SingleRecordEditField = (props) => {
    let index = props.index;
    return (


        <Field
            contentType="record"
            model={ "editRecord." + props.id }
            value={props.field_value}
            index={index}
            recordId={props.recordId}
            onChange={(e, value, index) => this.props.onChange(e, value, index)}
            {...props}
        />

    );

};
export default SingleRecordEditField;


// WEBPACK FOOTER //
// ./src/components/records/SingleRecordEditField.js